import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { TEGueltigkeitEntity } from '../../../entities/mdqx/te-gueltigkeit.entity';
import { TEGueltigkeitActions, TEGueltigkeitActionTypes } from '../../actions/mdqx/te-gueltigkeit.actions';

export interface TEGueltigkeitState extends EntityState<TEGueltigkeitEntity> {
    fetched: boolean;
}

export const TEGUELTIGKEIT_KEY = 'tegueltigkeit';

const adapter = createEntityAdapter<TEGueltigkeitEntity>({
    selectId: tegueltigkeit => tegueltigkeit.Id,
});

const initialState: TEGueltigkeitState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function teGueltigkeitReducer(state = initialState, action: TEGueltigkeitActions) {
    switch (action.type) {
        case TEGueltigkeitActionTypes.GetTEGueltigkeitenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllTEGueltigkeiten = selectAll;

export const selectTEGueltigkeitenFetched = (state: TEGueltigkeitState) => state.fetched;
